import DamageReport from './damageReport';

export default DamageReport;
